'use client';

import { Divider, Padding, Typography } from '@musinsa/mds';
import { useDeviceInfo } from '@musinsa/packages-device-detection';
import Image from 'next/image';
import { getIntroContent } from '../introContent';

export const IntroHeroSection = () => {
  const { service } = useDeviceInfo();
  const { hero: content } = getIntroContent(service);

  return (
    <div>
      <Padding top="8" bottom="4" x="4" className="text-center bg-gray-200">
        <Typography variant="title26pxMed">
          나만의 큐레이션 상품으로
          <br />
          수익을 창출해 보세요
        </Typography>
      </Padding>

      <div className="w-full relative bg-gray-200">
        <Image
          src={content.image}
          alt="intro-service-overview-01"
          width={0}
          height={0}
          sizes="100vw"
          priority
          unoptimized
          className="bg-gray-200 w-full h-auto object-cover"
        />
      </div>
      <Padding top="5" x="4" className="text-center">
        <Typography variant="body14pxReg">
          {content.description.split('\n').map((line, i) => (
            <span key={i}>
              {i > 0 && <br />}
              {line}
            </span>
          ))}
        </Typography>
      </Padding>
      <Padding y="8" x="4">
        <Divider variant="line" colorScheme="gray-500" />
      </Padding>
    </div>
  );
};
